import { render, staticRenderFns } from "./GpathRoadmapAdd.vue?vue&type=template&id=b0752750&scoped=true"
import script from "./GpathRoadmapAdd.vue?vue&type=script&lang=js"
export * from "./GpathRoadmapAdd.vue?vue&type=script&lang=js"
import style0 from "./GpathRoadmapAdd.vue?vue&type=style&index=0&id=b0752750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0752750",
  null
  
)

export default component.exports